export default __webpack_public_path__ + "static/media/Brakes_status.f2a7a6ea.svg";